<div class="query-chart">
  <div class="chart" *ngIf="!loading" [chart]="stockChart"></div>
  <div class="loading" *ngIf="loading">
    <mat-spinner [diameter]="50"></mat-spinner>
  </div>
</div>
